jQuery('body').on('submit', 'form.newsletter-signup-form', function (){
    fbq('track', 'Lead');
});

(function loadConsentMode() {
    jQuery('body').on('click', '#shopify-pc__banner__btn-accept', function (){
        gtag('consent', 'update', {
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'ad_storage': 'granted',
            'analytics_storage': 'granted'
        });
    })
})();

(function (){
    let initRibbonClick = function () {
        jQuery('.giftpush-container:not(.keep-opened) .giftpush-ribbon').on('click', function () {
            jQuery('.giftpush-container').toggleClass('active');
        })
    }

    let initOutsideRibbonClick = function () {
        if (jQuery('.giftpush-container:not(.keep-opened)').length) {
            jQuery(document).click(function (event) {
                var $target = jQuery(event.target);
                if (!$target.closest('.giftpush-container').length &&
                        jQuery('.giftpush-container').hasClass('active')) {
                    jQuery('.giftpush-container').removeClass('active');
                }
            });
        }
    }

    initRibbonClick();
    initOutsideRibbonClick();

    if (Shopify.designMode) {
        jQuery(document).on('shopify:section:load shopify:section:reorder', function (){
            initRibbonClick();
        });
    }
})();

(function (){
    jQuery(window).on('scroll', function (){
        let header = jQuery("#shopify-section-header")
        let message_bar = jQuery('#shopify-section-announcement-bar');
        if(jQuery(document).scrollTop() >= (message_bar.height() * 3.5)) {
            header.addClass('sticky-active');
            message_bar.addClass("hidden");
        } else if (jQuery(document).scrollTop() <= 5) {
            header.removeClass('sticky-active');
            message_bar.removeClass("hidden");
        }
    })
})();

(function (){
    initLoginWall();
    jQuery(document).on('shopify:section:load shopify:section:reorder', function (event){
        if (jQuery('#section-id-' + event.detail.sectionId + '[data-section-type="login-wall"][data-enabled]').length) {
            initLoginWall();
        }
    });

    jQuery(document).on('shopify:section:unload', function (event){
        if (jQuery('#section-id-' + event.detail.sectionId + '[data-section-type="login-wall"]').length) {
            unloadLoginWall();
        }
    });

    function initLoginWall() {
        if(jQuery('[data-section-type="login-wall"][data-enabled]').length)
            jQuery('main#content').addClass('login-required');
    }

    function unloadLoginWall() {
        if(jQuery('[data-section-type="login-wall"]').length)
            jQuery('main#content').removeClass('login-required');
    }
})();

if (iOS()) {
    jQuery('body').on('click touchstart', function () {
        jQuery('.product-block__image.with-video video').trigger('play');
    });
    jQuery(document).on('ccc:ajax-components:loaded cc:search-complete cc:ajax-collection:infinite-scroll-new-page', () => {
        jQuery('.product-block__image.with-video video').trigger('play');
    })
}

function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

(function(){
    if (jQuery('.scroll-top-container').length){
        jQuery(window).scroll(function () {
            let scroll = jQuery(window).scrollTop();
            if(scroll > 150)
                jQuery('.scroll-top-container').fadeIn();
            else
                jQuery('.scroll-top-container').fadeOut()
        });

        jQuery('.scroll-top-arrow').on('click', function (){
            jQuery('html, body').animate({scrollTop: 0}, 'slow');
        });
    }
}());

(function (){

    if(!jQuery('#recharge-te .edit_subscription_info-product:contains("L\'abonnement PDF & son Kit Citronné")').length)
        return;

   let now = new Date();
   let first_march_2024 = new Date(2024, 02, 01);
   if (now < first_march_2024)
       jQuery('#recharge-te .rc_cancel-btn').hide().prop('disabled', true);
})();

//Klaviyo button popup trigger
(function () {
    window._klOnsite = window._klOnsite || [];
    jQuery('[data-klaviyo-form-id]').on('click', function (event){
        event.preventDefault();
        window._klOnsite.push(['openForm', jQuery(this).data('klaviyo-form-id')]);
    })
})();